/* Entry point that ensures correct ordering of imported external styles. */

import '@dr.pogodin/react-utils/global-styles.scss';
import 'styles/global.scss';

import App from './app';

export default App;
